import {UIElement} from "./ui";
import '/modules/common/css/ui/panel.css';
import '/modules/common/css/ui/panel.responsive.css';
import '/modules/common/css/ui/panel.mobile.css';

/**
 * A panel that is collapsible
 * @extends UIElement
 */
class Panel extends UIElement {

    /**
     *
     * @param id {string} Panel id
     * @param startCollapsedIfSmall {boolean}  If this map is on a small container, should the panel startup collapsed?
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(id, startCollapsedIfSmall, onChangeRuntimeConfig) {
        super(id, onChangeRuntimeConfig);
        this.startCollapsedIfSmall = startCollapsedIfSmall;
        this.renderHeader = true;

        const expanded = this.getSessionProp("expanded");
        this.expanded = expanded === 'true';
    }

    getClassName(){
        return "Panel";
    }

    getClasses(){
        return '';
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<section id="' + this.id + '" class="'+this.getClasses()+' panel-container ol-unselectable ol-control"></section>'
            );

            if(this.renderHeader){
                this.uiElement.append($(
                    '<header class="panel-container-header expanded">'
                    + ' <div class="panel-container-title">' + this.getTitleText() + '</div>'
                    + ' <div class="panel-container-expander "><button title="' + tumbo.translator.translate('panel.expandCollapse') + '" class="expand-button expanded"></button></div>'
                    + '</header>')
                );
            }
            this.uiElement.append($('<div class="panel-container-body" tabindex="0"></div>'));

            $('.panel-container-body', this.uiElement).append(this.getPanelContent());

            if(this.renderHeader) {
                this.onAdd2DOM(()=>{
                    $('.panel-container-header', this.uiElement).click(() => {
                        if (!this.isExpanded()) {
                            this.expand();
                            this.logStat("EXPAND");
                        } else {
                            this.collapse();
                            this.logStat("COLLAPSE");
                        }
                    });
                });

                const isExpanded = this.getSessionProp("expanded");
                let shouldCollapse = false;
                if (isExpanded === 'true') {
                    shouldCollapse = false;
                } else if (isExpanded === 'false') {
                    shouldCollapse = true;
                } else {
                    shouldCollapse = this.startCollapsedIfSmall && (tumbo.isMobileDevice || this.isSmallContainerWidth || this.isSmallContainerHeight);
                }
                if (shouldCollapse) {
                    this.collapse();
                } else this.expand();
            } else this.uiElement.addClass('no-header')
            this.onFocusedEnterOrSpace(()=>$('.panel-container-header', this.uiElement).click());
        }
        return this.uiElement;
    }

    isExpanded(){
        return this.expanded;
    }

    /**
     * Expand this panel if it is collapsed
     * @return {Panel} this panel
     */
    expand() {
        $('.panel-container-body', this.getUIElement()).show().removeClass('hidden');
        $('.panel-container-expander button', this.getUIElement()).addClass('expanded');
        $('.panel-container-header', this.getUIElement()).addClass('expanded');
        this.getUIElement().addClass('expanded');
        this.setSessionProp("expanded","true");
        this.expanded = true;
        if(this.onExpandCallbacks)
            this.onExpandCallbacks.forEach(c=>c());
        return this;
    }

    /**
     * Collapse this panel if it is expanded
     * @return {Panel} this panel
     */
    collapse() {
        $('.panel-container-body', this.getUIElement()).hide().addClass('hidden');
        $('.panel-container-expander button', this.getUIElement()).removeClass('expanded');
        $('.panel-container-header', this.getUIElement()).removeClass('expanded');
        this.getUIElement().removeClass('expanded');
        this.setSessionProp("expanded","false");
        this.expanded = false;
        if(this.onCollapseCallbacks)
            this.onCollapseCallbacks.forEach(c=>c());
        return this;
    }

    onExpand(callback){
        if(!this.onExpandCallbacks)
            this.onExpandCallbacks = [];
        this.onExpandCallbacks.push(callback);
        return this;
    }

    onCollapse(callback){
        if(!this.onCollapseCallbacks)
            this.onCollapseCallbacks = [];
        this.onCollapseCallbacks.push(callback);
        return this;
    }

    /**
     * Get this panel's title
     * @return {string}
     */
    getTitleText() {
    }

    /**
     * Get this panel's content
     * @return {jQuery}
     */
    getPanelContent() {
    }

    getCode() {
        return this.id;
    }
}

export {Panel}